<template>
    <div class="box">
        <img class="img" src="@/assets/image6.png">
        <div class="message">
            <div class="title">Mail Address</div>
            <div class="info">Office A, RAK DAO Business Centre, RAK BANK ROC Office, Ground Floor, Al Rifaa, Sheikh Mohammed Bin Zayed Road, Ras Al Khaimah</div>
        </div>
    </div>
</template>

<style scoped>
.box{
    display: flex;
    flex-direction: row;
}
.img{
    width: 39px;
    height: 39px;
}
.message{
    display: flex;
    flex-direction: column;
    padding-left: 16px;
}
.title{
    font-size: 14px;
    color: #fff;
    line-height: 18px;
    font-weight: 500;
}
.info{
    font-size: 12px;
    color: #fff;
    line-height: 18px;
    font-weight: 400;
}
</style>